import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import { FormattedMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Checkbox } from 'ui-components/components/checkbox';
import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { Text, TextType } from 'ui-components/components/text';

import AddressOptionsSection from './address-options';
import { useEditShipToFormContext } from './context';
import PasteAddressSection from './paste-address-section';
import { AddressFields } from '../../../../../../../address/address-fields';
import { EMAIL, PHONE } from '../../../../../../../address/constants';
import { MULTI_LINE_EMAIL_SUB_LABEL, PHONE_NEEDED_FOR_SOME_CARRIERS } from '../../../../../../../address/sublabel-constants';
import { US } from '../../../../../../../constants/country-codes';
import { useAddressValidatorConfig } from '../../../../../../../contexts/country-config-context/use-address-validator-config';
import messages from '../messages';
import style from './edit-shipto-modal.module.less';
import { ERR, WRN } from '../../../../../../../enums/address-verification-status';

const EditShipToModalBody = () => {
  const {
    formState,
    updateForm,
    validationErrors,
    apiError,
    clearApiError,
    shouldLock,
    setShouldLock,
    isValidatingAddress,
    validateAddress,
    isValid,
    isSaving,
    resetFormState,
    updateFormState,
  } = useEditShipToFormContext();
  const allowAddressValidation = useAddressValidatorConfig();

  const subLabels = {
    [PHONE]: PHONE_NEEDED_FOR_SOME_CARRIERS,
    [EMAIL]: MULTI_LINE_EMAIL_SUB_LABEL,
  };

  const { countryCode } = formState;
  const showPasteAddress = countryCode === US;
  return (
    <ModalBody>
      {!!apiError && (
        <BannerMessageV2
          content={<FormattedMessage {...messages.defaultErrorMessage} />}
          onClose={clearApiError}
          status={BannerStatus.Error}
        />
      )}
      <FlexRow className={style['subtitle-wrapper']}>
        <FlexColumn>
          <Text textType={TextType.H2} value={messages.modalSubTitle} />
        </FlexColumn>
        <FlexColumn>
          <Checkbox
            checked={shouldLock}
            className={style['address-option-checkbox']}
            label={
              <FormattedMessage
                {...messages.lockAddressLabel}
                values={{
                  lockIcon: <FontAwesomeIcon className={style['label-lock-icon']} icon={faLock} />,
                }}
              />
            }
            onChange={setShouldLock}
            tabIndex={0}
          />
        </FlexColumn>
      </FlexRow>
      {formState.verificationStatus === WRN && <BannerMessageV2 content={formState.verificationMessage} status={BannerStatus.Warning} />}
      {formState.verificationStatus === ERR && (
        <BannerMessageV2
          content={
            <FormattedMessage
              {...messages.verificationBannerErrorMessage}
              values={{ verificationMessage: formState.verificationMessage }}
            />
          }
          status={BannerStatus.Error}
        />
      )}
      <FlexRow className={style['edit-address-modal-body']}>
        <FlexColumn className={style.column}>
          <AddressFields
            address={formState}
            errors={validationErrors}
            line3
            onChange={updateForm}
            showAllErrors
            state
            subLabels={subLabels}
            type='v3'
          />
        </FlexColumn>
        <FlexColumn className={style.column}>
          {showPasteAddress ? <PasteAddressSection resetFormState={resetFormState} updateFormState={updateFormState} /> : null}
          {allowAddressValidation ? (
            <AddressOptionsSection
              formState={formState}
              isSaving={isSaving}
              isValid={isValid}
              isValidatingAddress={isValidatingAddress}
              validateAddress={validateAddress}
            />
          ) : null}
        </FlexColumn>
      </FlexRow>
    </ModalBody>
  );
};

export default EditShipToModalBody;
